import { IEndpointReponseProps } from "../../types";

// const baseURL = `${process.env.REACT_APP_BASE_URL}/api`;
const baseURL =
  "https://aisewave-app.icyground-9e9982ba.westus2.azurecontainerapps.io/api/v1";

export const Endpoints = {
  GetCheckServerHealth: (): IEndpointReponseProps => {
    return {
      route: `${baseURL}/health`,
      method: "GET",
    };
  },

  /* 
    AUTHENTICATION ENDPOINTS
  */

  GetRegisterToOrganization: (): IEndpointReponseProps => {
    return {
      route: `${baseURL}/attendee/register/`,
      method: "POST",
    };
  },
  GetResendRegisterOTP: (): IEndpointReponseProps => {
    return {
      route: `${baseURL}/attendee/register/resend-otp/`,
      method: "POST",
    };
  },
  GetVerifyRegisterOTP: (): IEndpointReponseProps => {
    return {
      route: `${baseURL}/attendee/register/confirm/`,
      method: "POST",
    };
  },
  GetLoginToOrganization: (): IEndpointReponseProps => {
    return {
      route: `${baseURL}/attendee/login/`,
      method: "POST",
    };
  },
  GetAttendeeProfile: (): IEndpointReponseProps => {
    return {
      route: `${baseURL}/attendee/profile/`,
      method: "GET",
    };
  },
  GetForgotPassword: (): IEndpointReponseProps => {
    return {
      route: `${baseURL}/attendee/forget-password/`,
      method: "POST",
    };
  },
  GetResendForgotPasswordOTP: (): IEndpointReponseProps => {
    return {
      route: `${baseURL}/attendee/forget-password/resend-otp/`,
      method: "POST",
    };
  },
  GetConfirmForgotPassword: (): IEndpointReponseProps => {
    return {
      route: `${baseURL}/attendee/forget-password/confirm/`,
      method: "POST",
    };
  },

  /*
    ORGANIZATION ENDPOINTS
  */
  GetSingleOrganization: (organizationSlug: string): IEndpointReponseProps => {
    return {
      route: `${baseURL}/organization/homepage?slug=${organizationSlug}`,
      method: "GET",
    };
  },

  GetOrganizationUsingWebsite: (website: string): IEndpointReponseProps => {
    return {
      route: `${baseURL}/organization/get-by-website/?website=${website}`,
      method: "GET",
    };
  },
  /*
    EVENT ENDPOINTS
  */
  GetSingleEvent: (eventID: string): IEndpointReponseProps => {
    return {
      route: `${baseURL}/organization/homepage/event?event_id=${eventID}`,
      method: "GET",
    };
  },
  GetOrganizationEvents: (
    startDate?: string,
    endDate?: string
  ): IEndpointReponseProps => {
    const params = new URLSearchParams();
    if (startDate) params.append("start_date", startDate);
    if (endDate) params.append("end_date", endDate);
    const queryString = params.toString();
    return {
      route: `${baseURL}/attendee/events/${
        queryString ? `?${queryString}` : ""
      }`,
      method: "GET",
    };
  },
  GetOrganizationEventsAll: (filters: {
    start_date?: string;
    end_date?: string;
    name?: string;
    type?: "online" | "offline" | "hybrid";
    category?: string;
    location_state?: string;
    location_country?: string;
    page?: number;
    page_size?: number;
  }): IEndpointReponseProps => {
    const params = new URLSearchParams();
    if (filters.start_date) params.append("start_date", filters.start_date);
    if (filters.end_date) params.append("end_date", filters.end_date);
    if (filters.name) params.append("name", filters.name);
    if (filters.type) params.append("type", filters.type);
    if (filters.category) params.append("category", filters.category);
    if (filters.location_state)
      params.append("location_state", filters.location_state);
    if (filters.location_country)
      params.append("location_country", filters.location_country);
    if (filters.page) params.append("page", filters.page.toString());
    if (filters.page_size)
      params.append("page_size", filters.page_size.toString());
    const queryString = params.toString();
    return {
      route: `${baseURL}/attendee/events${
        queryString ? `?${queryString}` : ""
      }`,
      method: "GET",
    };
  },
  GetFilterEvents: (
    organizationID: string,
    filters?: {
      start_date?: string;
      end_date?: string;
      name?: string;
      type?: "online" | "offline" | "hybrid";
      category?: string;
      location_state?: string;
      location_country?: string;
      page?: number;
      page_size?: number;
    }
  ): IEndpointReponseProps => {
    const params = new URLSearchParams();
    if (filters?.start_date) params.append("start_date", filters.start_date);
    if (filters?.end_date) params.append("end_date", filters.end_date);
    if (filters?.name) params.append("name", filters.name);
    if (filters?.type) params.append("type", filters.type);
    if (filters?.category) params.append("category", filters.category);
    if (filters?.location_state)
      params.append("location_state", filters.location_state);
    if (filters?.location_country)
      params.append("location_country", filters.location_country);
    if (filters?.page) params.append("page", filters.page.toString());
    if (filters?.page_size)
      params.append("page_size", filters.page_size.toString());
    const queryString = params.toString();
    return {
      route: `${baseURL}/attendee/events/organization/${organizationID}/filtered/${
        queryString ? `?${queryString}` : ""
      }`,
      method: "GET",
    };
  },

  /*
    EVENT TICKETS ENDPOINTS
  */
  GetBuyTickets: (): IEndpointReponseProps => {
    return {
      route: `${baseURL}/tickets/buy/`,
      method: "POST",
    };
  },
  GetAttendeeTickets: (): IEndpointReponseProps => {
    return {
      route: `${baseURL}/tickets/attendee/`,
      method: "GET",
    };
  },
  GetPaymentHistory: (): IEndpointReponseProps => {
    return {
      route: `${baseURL}/attendee/payments/history/`,
      method: "GET",
    };
  },

  /*
    MISC
  */
  GetSubscribeToNewsletter: (): IEndpointReponseProps => {
    return {
      route: `${baseURL}/organization/homepage/newsletter`,
      method: "POST",
    };
  },
  GetUploadFile: (): IEndpointReponseProps => {
    return {
      route: `${baseURL}/image/upload/`,
      method: "POST",
    };
  },
};
